import { registerFlow } from '../../../core/flow-register';
import { makeFlow } from '..';
import { IRAAccountTypes } from '../loaders';

registerFlow(
  makeFlow('sep-ira', {
    toIRAAccountType: IRAAccountTypes.TRADITIONAL,
    fromIRAAccountType: IRAAccountTypes.SEP
  })
);
